export function isPrint() {
  if (typeof window === 'undefined') return false
  return window.location?.hash === '#print'
}


export function hideKetchBannerInPrintMode() {
  if (isPrint()) {
    const style = document.createElement('style')
    style.textContent = '#lanyard_root, #hubspot-conversations-iframe { display: none !important; }'
    document.head.appendChild(style)
  }
}
